const snowSystem = {
  emitters: [
    {
      id: 1,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0],
          [1, 0],
        ],
      },
      angle: {
        type: 'float',
        value: 1.57,
      },
      speed: {
        type: 'range',
        value: [0.1, 0.3],
      },
      rate: {
        type: 'float',
        value: 20,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 20,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0,
        },
        wobble: {
          type: 'float',
          value: 10,
        },
        scale: {
          type: 'range',
          value: [0.5, 3],
        },
        color: {
          type: 'color',
          color: '#b08d60',
          value: [255, 255, 255, 0.9],
        },
      },
    },
    {
      id: 3,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 1.3],
          [1.2, 1.45],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0,
      },
      rate: {
        type: 'float',
        value: 20,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 14,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [40, 60],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#ab926b',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 40,
              value: [255, 255, 255, 0.25],
            },
            {
              keyframe: 60,
              value: [255, 255, 255, 0.25],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },
    {
      id: 6,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 200],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 20,
              value: [255, 255, 255, 0.002],
            },
            {
              keyframe: 40,
              value: [255, 255, 255, 0.002],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'time',
      emitters: [1, 10],
      energy: 'above',
      data: {
        amount: 2,
      },
    },
  ],
}

export default snowSystem
